module.exports = __webpack_public_path__ + "img/document-file.215db00d.svg";